import React, { FC, Fragment } from 'react';
import { SStepRail } from './StepRail.style';

type TStepRailProps = {
  /** Total number of steps. */
  count: number;
  /** Zero-based index of the current step. Steps before it render as done. */
  current: number;
};

const CheckIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6663 5L7.49967 14.1667L3.33301 10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Numbered progress rail (ZEST-738 2FA wizard). */
const StepRail: FC<TStepRailProps> = ({ count, current }) => (
  <SStepRail>
    {Array.from({ length: count }).map((_, i) => {
      let state: 'future' | 'active' | 'done' = 'future';
      if (i < current) state = 'done';
      else if (i === current) state = 'active';
      return (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={i}>
          {i > 0 && (
            <span
              className={`step-rail__line${
                i <= current ? ' step-rail__line--done' : ''
              }`}
            />
          )}
          <span className={`step-rail__node step-rail__node--${state}`}>
            {state === 'done' ? <CheckIcon /> : i + 1}
          </span>
        </Fragment>
      );
    })}
  </SStepRail>
);

export default StepRail;
